import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  cs: {
    translation: {
      common: {
        home: 'Domů',
        admin: 'Administrace',
        gallery: 'Moje galerie',
        profile: 'Můj profil',
        logout: 'Odhlásit se',
        login: 'Přihlášení',
        register: 'Registrace',
        save: 'Uložit',
        cancel: 'Zrušit',
        edit: 'Upravit',
        delete: 'Smazat',
        create: 'Vytvořit',
        loading: 'Načítání...',
        error: 'Chyba',
        success: 'Úspěšně',
        close: 'Zavřít',
        details: 'Detaily',
        images: 'Obrázky',
        events: 'Události',
        username: 'Uživatelské jméno',
        email: 'Email',
        bio: 'Biografie',
        approve: 'Schválit',
        reject: 'Zamítnout',
        actions: 'Akce',
        artworkType: 'Typ uměleckého díla',
        detail: 'Detail',
        noBio: 'Žádná biografie',
      },
      header: {
        title: 'Gallerouch Galerie',
        adminPanel: '⚙️ Administrace',
        myGallery: '📋 Moje galerie',
        myProfile: 'Můj profil',
        adminApprovals: '✅ Schvalování událostí',
        adminArtworkApprovals: '🎨 Schvalování artwork',
        adminProfileApprovals: '📋 Schvalování profilů',
      },
      account: {
        myAccount: 'Můj účet',
        administration: 'Administrace',
        myArtworks: '🎨 Moje díla',
        profileAndBanking: '👤 Profil a bankovní údaje',
        myEvents: '📌 Moje události',
        eventsDescription: 'Zde vidíte všechny své události (čekající i schválené).',
        adminGallery: '🎨 Umělecká díla',
        adminUsers: '👥 Uživatelé',
        adminApprovals: '✅ Schvalování událostí',
        adminArtworkApprovals: '🎨 Schvalování artwork',
        adminProfileApprovals: '📋 Schvalování profilů',
        adminPaymentsManager: '💰 Platby',
        adminSettings: '⚙️ Nastavení',
        adminArtworkTypes: '🎨 Typy uměleckých děl',
        adminAuthorApprovals: '👨‍🎨 Schválení bio & typů',
        authorProfile: '👨‍🎨 Autorský profil',
        searchArtworks: 'Hledat díla...',
        allUsers: 'Všichni uživatelé',
      },
      admin: {
        users: 'Uživatelé',
        approvals: 'Schvalování',
        events: 'Události',
        profileApprovals: 'Osobní údaje',
        managementUsers: 'Správa uživatelů',
        settings: 'Nastavení',
        payments: 'Platby',
        newUser: 'Nový uživatel',
        username: 'Uživatelské jméno',
        email: 'Email',
        role: 'Role',
        created: 'Vytvořeno',
        approve: 'Schválit',
        reject: 'Zamítnout',
        account: 'Účet',
        userProfile: 'Profil',
        authorApprovals: 'Schvalování autorských profilů',
        noPendingApprovals: 'Žádné čekající schválení autorských profilů',
        pendingApprovalsCount: 'Čekající schválení',
        artworkTypes: 'typy děl',
        pendingBios: 'Čekající biografie',
        pendingArtworkTypes: 'Čekající typy děl',
        bioDetail: 'Detail biografie',
        failedFetchPendingApprovals: 'Nepodařilo se načíst čekající schválení',
        failedApproveBio: 'Nepodařilo se schválit bio',
        failedRejectBio: 'Nepodařilo se zamítnout bio',
        failedApproveType: 'Nepodařilo se schválit typ díla',
        failedRejectType: 'Nepodařilo se zamítnout typ díla',
      },
      tabs: {
        basicInfo: '📝 Základní údaje',
        images: '🖼️ Obrázky',
        events: '📌 Události',
      },
      view: {
        cards: 'Zobrazení jako dlaždice',
        list: 'Zobrazení jako seznam',
      },
      events: {
        events: 'Události',
        approvals: 'Schvalování událostí',
        pending: 'Čekající',
        approved: 'Schválené',
        rejected: 'Odmítnuté',
        all: 'Všechny',
        noEvents: 'Žádné položky k schválení',
        loading: 'Načítání...',
        id: 'ID',
        artwork: 'Dílo',
        type: 'Typ',
        createdBy: 'Vytvořil',
        createdAt: 'Datum vytvoření',
        details: 'Detaily',
        status: 'Stav',
        actions: 'Akce',
        showDetails: 'Zobrazit',
        statusPending: '⏳ Čeká',
        statusApproved: '✅ Schváleno',
        statusRejected: '❌ Zamítnuto',
        typeCreated: 'Vytvořeno',
        typePriceChange: 'Změna ceny',
        typeStatusChange: 'Změna stavu',
        typeDeleted: 'Smazáno',
        typeOwnershipChange: 'Změna vlastníka',
        typeOwnerChange: 'Změna vlastníka',
        typeUpdated: 'Aktualizováno',
        approve: 'Schválit',
        reject: 'Zamítnout',
        approveEvent: 'Schválit událost',
        rejectEvent: 'Zamítnout událost',
        confirmApprove: 'Jste si jisti, že chcete schválit tuto událost?',
        confirmReject: 'Prosím, zadejte důvod zamítnutí:',
        reason: 'Důvod',
        myEvents: 'Moje události',
        created: 'Vytvořeno',
        price: 'Cena',
        loadError: 'Chyba při načítání událostí',
      },
      actions: {
        editArtwork: 'Upravit artwork',
        deleteArtwork: 'Smazat artwork',
        deleteEvent: 'Smazat událost',
        editProfile: 'Editovat profil',
        editAccount: 'Editovat účet',
        deleteUser: 'Smazat uživatele',
        approve: 'Schválit',
        reject: 'Zamítnout',
        toggleLanguage: 'Přepnout jazyk',
      },
      gallery: {
        all: 'Všechna',
        allArtworks: 'Všechny artwork',
        myArtworks: 'Moje artwork',
        newArtwork: '➕ Přidat nový artwork',
        editArtwork: 'Upravit artwork',
        author: 'Autor',
        price: 'Cena',
        status: 'Stav',
        description: 'Popis',
        search: '🔍 Hledat (název, status)',
        clear: '🗑️ Vyčistit',
        refresh: '🔄 Obnovit',
        artworkTitle: 'Název',
        artworkDescription: 'Popis',
        artworkPrice: 'Cena (Kč)',
        artworkStatus: 'Status',
        artworkOwner: 'Vlastník',
        artworkType: 'Typ uměleckého díla',
        selectType: 'Vyberte typ',
        statusHidden: 'Skryto',
        statusExhibited: 'Vystaveno',
        statusForSale: 'K prodeji',
        statusReserved: 'Rezervováno',
        statusCancelled: 'Zrušeno',
        statusSkryto: 'Skryto',
        statusVystaveno: 'Vystaveno',
        statusK_prodeji: 'K prodeji',
        statusRezervováno: 'Rezervováno',
        statusZrušeno: 'Zrušeno',
        hidden: 'Skryto',
        exhibited: 'Vystaveno',
        forSale: 'K prodeji',
        reserved: 'Rezervováno',
        cancelled: 'Zrušeno',
        searchArtworks: 'Hledat díla...',
        allUsers: 'Všichni uživatelé',
        total: 'Celkem',
        filtered: 'Filtrováno',
        noArtworks: 'Žádná díla',
        uploadImage: 'Nahrát obrázek',
        imageFormat: 'Vyberte JPG, PNG apod.',
        displayed: 'Zobrazeno',
        of: 'z',
        edit: 'Upravit',
        editArtworkModal: 'Upravit dílo',
        fieldTitle: 'Název',
        fieldDescription: 'Popis',
        fieldPrice: 'Cena',
        fieldStatus: 'Stav',
        titleCannotBeChanged: 'Název nelze měnit',
        descriptionCannotBeChanged: 'Popis nelze měnit',
        changesRequireApproval: 'Změny budou vyžadovat schválení administrátorem',
        changesAutoApproved: 'Jako administrátor budou vaše změny automaticky schváleny',
        delete: 'Smazat',
        allStatuses: 'Vše',
        hiddenShort: 'Skr.',
        exhibitedShort: 'Vyst.',
        soldShort: 'Prod.',
        cancelledShort: 'Zruš.',
        notFound: 'Žádná díla neodpovídají vašim kritériím.',
        works: 'děl',
        browseByStatus: 'Procházet podle stavu',
        browseByUsers: 'Procházet podle autorů a majitelů',
        authors: 'Autoři',
        owners: 'Majitelé',
        owner: 'Majitel',
        filterByType: 'Filtrovat podle typu',
        clearFilters: 'Vyčistit filtry',
        mode: 'režim',
        cardView: 'Zobrazení karty',
        listView: 'Zobrazení seznamu',
        artworkTypes: 'Typy uměleckých děl',
        selectAuthor: 'Vyberte autora...',
        authorHelp: 'Autor díla (nemění se při prodeji)',
        approvedTypesOnly: 'Jsou dostupné jen typy, které máte schválené v profilu',
        confirmDeleteArtwork: 'Opravdu chcete smazat tento artwork?',
        editNotAllowed: 'Upravit může pouze současný majitel.',
        deleteNotAllowed: 'Smazat může pouze současný majitel.',
      },
      offers: {
        makeOffer: 'Nabídnout cenu',
        myOffers: 'Moje nabídky',
        offersReceived: 'Přijaté nabídky',
        offeredPrice: 'Nabízená cena',
        message: 'Zpráva',
        offerMessage: 'Zpráva k nabídce (volitelné)',
        submitOffer: 'Odeslat nabídku',
        artwork: 'Dílo',
        buyer: 'Zájemce',
        status: 'Stav',
        statusPending: 'Čeká',
        statusAccepted: 'Přijato',
        statusRejected: 'Zamítnuto',
        createdAt: 'Vytvořeno',
        unread: 'Nepřečteno',
        markAsRead: 'Označit jako přečtené',
        accept: 'Přijmout',
        reject: 'Zamítnout',
        noOffers: 'Zatím žádné nabídky',
        offerSubmitted: 'Nabídka byla úspěšně odeslána',
        offerError: 'Chyba při odesílání nabídky',
        priceRequired: 'Prosím zadejte nabízenou cenu',
        pricePositive: 'Cena musí být větší než 0',
        offerOnlyExhibited: 'Nabídku lze odeslat pouze u vystavených děl',
        cannotOfferOwnArtwork: 'Nemůžete nabídnout cenu na své vlastní dílo',
        unreadCount: 'nabídek',
        viewOffers: 'Zobrazit nabídky',
        payment: 'Platba',
        paymentUnpaid: 'Nezaplaceno',
        paymentPaid: 'Zaplaceno',
        paymentMissing: 'Platba nenalezena',
        openDetail: 'Detail',
        payNow: 'Zaplatit',
      },
      artworkApprovals: {
        artworkApprovals: 'Přehled Schválení Artwork',
        allArtworks: 'Všechny',
        approvedArtworks: 'Schválené',
        pendingArtworks: 'Neschválené',
        rejectedArtworks: 'Odmítnuté',
        noArtworksWithEvents: 'Žádné artwork s events',
        artwork: 'Obraz',
        author: 'Autor',
        price: 'Cena',
        status: 'Status',
        eventCount: 'Počet Events',
        actions: 'Akce',
        hideEvents: 'Skrýt',
        showEvents: 'Zobrazit',
        events: 'Events',
        eventsFor: 'Events pro',
        type: 'Typ',
        createdAt: 'Vytvořeno',
        approvedAt: 'Schváleno',
        notApproved: 'Neschváleno',
        approveEvent: 'Schválení Eventu',
        rejectEvent: 'Zamítnutí Eventu',
        rejectReason: 'Důvod zamítnutí:',
        rejectPlaceholder: 'Vysvětlete, proč jste event zamítli...',
        confirmApproveEvent: 'Jste si jisti, že chcete tento event schválit?',
        confirmRejectEvent: 'Jste si jisti, že chcete tento event zamítnout?',
        approveButton: 'Schválit',
        rejectButton: 'Zamítnout',
        cancelButton: 'Zrušit',
        loadingArtworks: 'Načítám...',
        typeCreated: 'Vytvořeno',
        typeUpdated: 'Aktualizováno',
        typePriceChange: 'Změna ceny',
        typeStatusChange: 'Změna stavu',
        typeDeleted: 'Smazáno',
        typeOwnershipChange: 'Změna vlastníka',
        eventStatusApproved: 'Schváleno',
        eventStatusPending: 'Čekající',
        eventStatusRejected: 'Zamítnuté',
        statusVystaveno: 'Vystaveno',
        statusZrušeno: 'Zrušeno',
        statusSkryto: 'Skryto',
      },
      settings: {
        title: 'Nastavení aplikace',
        createNew: 'Vytvořit nastavení',
        noSettings: 'Žádná nastavení',
        key: 'Klíč',
        value: 'Hodnota',
        description: 'Popis',
        updatedAt: 'Aktualizováno',
        actions: 'Akce',
        editSetting: 'Upravit nastavení',
        createSetting: 'Vytvořit nastavení',
        edit: 'Upravit',
        delete: 'Smazat',
        create: 'Vytvořit',
        saveSettings: 'Uložit nastavení',
        loadError: 'Chyba při načítání nastavení',
        saveError: 'Chyba při ukládání nastavení',
        saveSuccess: 'Nastavení úspěšně uloženo',
        createSuccess: 'Nastavení úspěšně vytvořeno',
        deleteSuccess: 'Nastavení úspěšně smazáno',
        galleryBankAccount: 'Číslo bankovního účtu galerie',
        galleryCommissionPercent: 'Procento provize galerie (%)',
        galleryName: 'Název galerie',
        galleryEmail: 'Email galerie',
        galleryPhone: 'Telefon galerie',
        vatRate: 'Sazba DPH (%)',
        currency: 'Měna',
        minOrderAmount: 'Minimální částka objednávky',
        shippingEnabled: 'Povolit dopravu',
        paymentGatewayEnabled: 'Povolit platební bránu',
        registrationEnabled: 'Povolit registraci',
      },
      authorBio: {
        authorProfile: 'Autorský profil',
        biography: 'Biografie',
        biographyCzech: 'Biografie (Česky)',
        biographyEnglish: 'Biografie (Anglicky)',
        refresh: '🔄 Obnovit',
        refreshTooltip: 'Znovu načíst profil (např. po schválení adminem)',
        refreshProfile: 'Obnovit',
        pendingApproval: '⏳ Váš profil čeká na schválení adminem',
        approved: 'Schváleno',
        pending: 'Čeká na schválení',
        aboutYou: 'O vás',
        describeYourself: 'Popište sebe a svou tvorbu',
        describeYourselfEnglish: 'Describe yourself and your work in English',
        aboutYouPlaceholder: 'Napište něco o sobě, své tvorbě, inspiraci...',
        aboutYouPlaceholderEnglish: 'Write something about yourself, your work, inspiration...',
        artworkTypes: 'Typy uměleckých děl',
        selectArtworkTypes: 'Vyberte typy děl, které tvoříte. Po schválení adminem budete moci vytvářet díla těchto typů.',
        saving: '⏳ Ukládám...',
        saveProfile: '💾 Uložit profil',
        saveProfileButton: 'Uložit profil',
        changesNeedApproval: 'Změny profilu musí být schváleny adminem',
        profileSubmitted: 'Profil byl odeslán ke schválení adminem',
      },
      profile: {
        myProfile: 'Můj profil',
        basicInfo: 'Základní informace',
        username: 'Uživatelské jméno',
        email: 'Email',
        role: 'Role',
        personalData: 'Osobní údaje',
        birthNumber: 'Rodné číslo',
        birthNumberFormat: 'Formát: RRMMDD/XXXX',
        birthNumberPlaceholder: 'např. 123456/7890',
        permanentAddress: 'Adresa trvalého pobytu',
        correspondenceAddress: 'Korespondenční adresa',
        street: 'Ulice a číslo popisné',
        streetPlaceholder: 'např. Nová 123',
        city: 'Město',
        cityPlaceholder: 'např. Praha',
        postalCode: 'PSČ',
        postalCodePlaceholder: 'např. 110 00',
        country: 'Země',
        countryPlaceholder: 'např. Česká republika',
        bankingDetails: 'Bankovní detaily',
        accountNumber: 'Číslo účtu',
        accountNumberPlaceholder: 'např. 123-456789012/0100',
        bankCode: 'Kód banky',
        bankCodePlaceholder: 'např. 0100',
        bankName: 'Název banky',
        bankNamePlaceholder: 'např. Česká spořitelna',
        notFilled: 'Není vyplněno',
        approved: '✅ Schváleno',
        pending: '⚠️ Neschváleno',
        approvalPending: '⚠️ Profil čeká na schválení administrátorem',
        approvalPendingMessage: 'Vaše osobní údaje byly uloženy, ale ještě nebyly schváleny. Prosím čekejte na kontrolu administrátora.',
        approvalStatus: 'Stav schválení',
        approvedDate: 'Schváleno',
        editProfile: 'Upravit profil',
        saving: 'Ukládání...',
        failedLoadProfile: 'Nepodařilo se načíst profil',
        failedUpdateProfile: 'Nepodařilo se aktualizovat profil',
        profileNotFound: 'Profil nenalezen',
        approvals: 'Schvalování profilů',
        pendingApprovals: 'Čekající na schválení',
        approvedProfiles: 'Schválené',
        rejectedProfiles: 'Odmítnuté',
        allUsers: 'Všichni uživatelé',
        registered: 'Registrován',
        profileDetails: 'Detail profilu',
        approveProfileButton: 'Schválit profil',
        rejectProfileButton: 'Zamítnout profil',
        detail: 'Detail',
        failedFetchUsers: 'Nepodařilo se načíst uživatele',
        failedApproveProfile: 'Nepodařilo se schválit profil',
        failedRejectProfile: 'Nepodařilo se zamítnout profil',
      },
      buttons: {
        save: 'Uložit změny',
        create: 'Vytvořit',
        cancel: 'Zrušit',
        edit: 'Upravit',
        delete: 'Smazat',
        search: 'Hledat',
        clear: 'Vyčistit',
        new: 'Nový',
        refresh: 'Obnovit',
        approve: 'Schválit',
        reject: 'Zamítnout',
        buy: 'Koupit',
        confirmPayment: 'Potvrdit platbu',
        sendInvoice: 'Odeslat fakturu',
        backToGallery: 'Zpět do galerie',
      },
      artworkDetail: {
        notFound: 'Dílo nebylo nalezeno',
        loadError: 'Chyba při načítání detailu díla',
        noImage: 'Bez obrázku',
        description: 'Popis',
        author: 'Autor',
        price: 'Cena',
        notForSale: 'Toto dílo není k prodeji',
        notAvailable: 'Toto dílo momentálně není k prodeji',
        payWithQr: 'Proveďte prosím platbu za dílo pomocí QR kódu',
        alreadyExhibited: 'Toto dílo bylo vystaveno',
        loginRequired: 'Pro nákup se musíte přihlásit',
        noPriceSet: 'Cena není stanovena',
        confirmPurchase: 'Opravdu chcete koupit "{{title}}" za {{price}}?',
        purchaseSuccess: 'Nákup byl úspěšný! Platba čeká na potvrzení administrátorem.',
        purchaseError: 'Nepodařilo se dokončit nákup',
        processing: 'Zpracovávání...',
        history: 'Historie díla',
        noHistory: 'Žádná schválená historie',
        date: 'Datum',
        eventType: 'Typ události',
        status: 'Stav',
        details: 'Detaily',
      },
      payments: {
        title: 'Správa plateb',
        myPayments: 'Moje platby',
        adminOnly: 'Pouze pro administrátory',
        loadError: 'Chyba načítání plateb',
        noPayments: 'Zatím nejsou žádné platby',
        id: 'ID',
        varSymbol: 'Var. symbol',
        artwork: 'Dílo',
        buyer: 'Kupující',
        seller: 'Prodávající',
        role: 'Role',
        price: 'Cena',
        commission: 'Provize',
        sellerAmount: 'Prodejci',
        status: 'Stav',
        created: 'Vytvořeno',
        actions: 'Akce',
        paidAt: 'Zaplaceno',
        statusUnpaid: 'Nezaplaceno',
        statusPaid: 'Zaplaceno',
        statusCancelled: 'Zrušeno',
        confirmPaymentTitle: 'Potvrdit platbu',
        confirmSuccess: 'Platba byla potvrzena',
        confirmError: 'Chyba potvrzení platby',
        paymentMethod: 'Způsob platby',
        paymentMethodPlaceholder: 'např. Bankovní převod, Hotově',
        transactionId: 'ID transakce',
        transactionIdPlaceholder: 'Volitelné',
        notes: 'Poznámky',
        notesPlaceholder: 'Volitelné poznámky',
        sendInvoiceTitle: 'Odeslat fakturu',
        invoiceNumber: 'Číslo faktury',
        invoiceNumberRequired: 'Číslo faktury je povinné',
        invoiceNumberPlaceholder: 'např. 2025001',
        invoiceSent: 'Faktura odeslána',
        invoiceError: 'Chyba při odesílání faktury',
        cannotBuyOwnArtwork: 'Nemůžete koupit své vlastní dílo',
        scanQRCode: 'Naskenujte QR kód pro zaplacení',
        amount: 'Částka',
        variableSymbol: 'Variabilní symbol',
        description: 'Popis',
        bankAccount: 'Bankovní účet',
        paymentPending: 'Čeká se na zaplacení',
        paymentConfirmed: 'Platba byla potvrzena',
        roleBuyer: 'Kupující',
        roleSeller: 'Prodávající',
        asBuyer: 'Jako kupující',
        asSeller: 'Jako prodávající',
        allPayments: 'Všechny platby',
        confirmed: 'Potvrzeno',
        invoice: 'Faktura',
        view: 'Zobrazit',
        viewAll: 'Všechny platby',
        viewByUser: 'Podle uživatele',
        filterAll: 'Vše',
        sellersTotal: 'Celkem prodejcům',
      },
      messages: {
        loadingUsers: 'Načítám uživatele...',
        noUsers: 'Žádní uživatelé k zobrazení',
        userCreated: 'Uživatel byl vytvořen',
        userUpdated: 'Uživatel byl aktualizován',
        userDeleted: 'Uživatel byl smazán',
        artworkCreated: 'Artwork byl vytvořen',
        artworkUpdated: 'Artwork byl aktualizován',
        artworkDeleted: 'Artwork byl smazán',
        profileUpdated: 'Profil byl aktualizován',
        confirmDelete: 'Opravdu chcete smazat?',
        error: 'Došlo k chybě',
      },
    },
  },
  en: {
    translation: {
      common: {
        home: 'Home',
        admin: 'Administration',
        gallery: 'My Gallery',
        profile: 'My Profile',
        logout: 'Logout',
        login: 'Login',
        register: 'Register',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        create: 'Create',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        close: 'Close',
        details: 'Details',
        images: 'Images',
        events: 'Events',
        username: 'Username',
        email: 'Email',
        bio: 'Biography',
        approve: 'Approve',
        reject: 'Reject',
        actions: 'Actions',
        artworkType: 'Artwork Type',
        detail: 'Detail',
        noBio: 'No biography',
      },
      header: {
        title: 'Gallerouch Gallery',
        adminPanel: '⚙️ Administration',
        myGallery: '📋 My Gallery',
        myProfile: 'My Profile',
        adminApprovals: '✅ Event Approvals',
        adminArtworkApprovals: '🎨 Artwork Approvals',
        adminProfileApprovals: '📋 Profile Approvals',
      },
      account: {
        myAccount: 'My Account',
        administration: 'Administration',
        myArtworks: '🎨 My Artworks',
        profileAndBanking: '👤 Profile & Banking Details',
        myEvents: '📌 My Events',
        eventsDescription: 'Here you can see all your events (pending and approved).',
        adminGallery: '🎨 Artworks',
        adminUsers: '👥 Users',
        adminApprovals: '✅ Event Approvals',
        adminArtworkApprovals: '🎨 Artwork Approvals',
        adminProfileApprovals: '📋 Profile Approvals',
        adminPaymentsManager: '💰 Payments',
        adminSettings: '⚙️ Settings',
        adminArtworkTypes: '🎨 Artwork Types',
        adminAuthorApprovals: '👨‍🎨 Author Bio & Types Approvals',
        authorProfile: '👨‍🎨 Author Profile',
        searchArtworks: 'Search artworks...',
        allUsers: 'All users',
      },
      tabs: {
        basicInfo: '📝 Basic Information',
        images: '🖼️ Images',
        events: '📌 Events',
      },
      view: {
        cards: 'View as cards',
        list: 'View as list',
      },
      events: {
        events: 'Events',
        approvals: 'Event Approvals',
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        all: 'All',
        noEvents: 'No items to approve',
        loading: 'Loading...',
        id: 'ID',
        artwork: 'Artwork',
        type: 'Type',
        createdBy: 'Created by',
        createdAt: 'Created at',
        details: 'Details',
        status: 'Status',
        actions: 'Actions',
        showDetails: 'Show',
        statusPending: '⏳ Pending',
        statusApproved: '✅ Approved',
        statusRejected: '❌ Rejected',
        typeCreated: 'Created',
        typePriceChange: 'Price change',
        typeStatusChange: 'Status change',
        typeDeleted: 'Deleted',
        typeOwnershipChange: 'Ownership change',
        typeOwnerChange: 'Ownership change',
        typeUpdated: 'Updated',
        approve: 'Approve',
        reject: 'Reject',
        approveEvent: 'Approve event',
        rejectEvent: 'Reject event',
        confirmApprove: 'Are you sure you want to approve this event?',
        confirmReject: 'Please provide a reason for rejection:',
        reason: 'Reason',
        myEvents: 'My Events',
        created: 'Created',
        loadError: 'Error loading events',
      },
      actions: {
        editArtwork: 'Edit artwork',
        deleteArtwork: 'Delete artwork',
        deleteEvent: 'Delete event',
        editProfile: 'Edit profile',
        editAccount: 'Edit account',
        deleteUser: 'Delete user',
        approve: 'Approve',
        reject: 'Reject',
        toggleLanguage: 'Toggle language',
      },
      gallery: {
        all: 'All',
        allArtworks: 'All Artworks',
        myArtworks: 'My Artworks',
        newArtwork: '➕ Add New Artwork',
        editArtwork: 'Edit Artwork',
        author: 'Author',
        price: 'Price',
        status: 'Status',
        description: 'Description',
        search: '🔍 Search (title, status)',
        clear: '🗑️ Clear',
        refresh: '🔄 Refresh',
        artworkTitle: 'Title',
        artworkDescription: 'Description',
        artworkPrice: 'Price (CZK)',
        artworkStatus: 'Status',
        artworkOwner: 'Owner',
        artworkType: 'Artwork Type',
        selectType: 'Select type',
        statusHidden: 'Hidden',
        statusExhibited: 'Exhibited',
        statusForSale: 'For Sale',
        statusReserved: 'Reserved',
        statusSold: 'Sold',
        statusCancelled: 'Cancelled',
        statusSkryto: 'Hidden',
        statusVystaveno: 'Exhibited',
        statusK_prodeji: 'For Sale',
        statusRezervováno: 'Reserved',
        statusZrušeno: 'Cancelled',
        hidden: 'Hidden',
        exhibited: 'Exhibited',
        forSale: 'For Sale',
        reserved: 'Reserved',
        cancelled: 'Cancelled',
        searchArtworks: 'Search artworks...',
        allUsers: 'All users',
        total: 'Total',
        filtered: 'Filtered',
        noArtworks: 'No artworks',
        uploadImage: 'Upload image',
        imageFormat: 'Select JPG, PNG, etc.',
        displayed: 'Displayed',
        of: 'of',
        edit: 'Edit',
        editArtworkModal: 'Edit artwork',
        fieldTitle: 'Title',
        fieldDescription: 'Description',
        fieldPrice: 'Price',
        fieldStatus: 'Status',
        titleCannotBeChanged: 'Title cannot be changed',
        descriptionCannotBeChanged: 'Description cannot be changed',
        changesRequireApproval: 'Changes will require administrator approval',
        changesAutoApproved: 'As an administrator, your changes will be automatically approved',
        delete: 'Delete',
        allStatuses: 'All',
        hiddenShort: 'Hidd.',
        exhibitedShort: 'Exhib.',
        soldShort: 'Sold',
        cancelledShort: 'Canc.',
        notFound: 'No artworks matching your criteria.',
        works: 'works',
        browseByStatus: 'Browse by status',
        browseByUsers: 'Browse by authors and owners',
        authors: 'Authors',
        owners: 'Owners',
        owner: 'Owner',
        filterByType: 'Filter by type',
        clearFilters: 'Clear filters',
        mode: 'mode',
        cardView: 'Card view',
        listView: 'List view',
        artworkTypes: 'Artwork Types',
        selectAuthor: 'Select author...',
        authorHelp: 'Artwork author (does not change after sale)',
        approvedTypesOnly: 'Only artwork types approved in your profile are available',
        confirmDeleteArtwork: 'Are you sure you want to delete this artwork?',
        editNotAllowed: 'Only the current owner can edit this artwork.',
        deleteNotAllowed: 'Only the current owner can delete this artwork.',
      },
      offers: {
        makeOffer: 'Make Offer',
        myOffers: 'My Offers',
        offersReceived: 'Offers Received',
        offeredPrice: 'Offered Price',
        message: 'Message',
        offerMessage: 'Offer message (optional)',
        submitOffer: 'Submit Offer',
        artwork: 'Artwork',
        buyer: 'Buyer',
        status: 'Status',
        statusPending: 'Pending',
        statusAccepted: 'Accepted',
        statusRejected: 'Rejected',
        createdAt: 'Created',
        unread: 'Unread',
        markAsRead: 'Mark as Read',
        accept: 'Accept',
        reject: 'Reject',
        noOffers: 'No offers yet',
        offerSubmitted: 'Offer submitted successfully',
        offerError: 'Error submitting offer',
        priceRequired: 'Please enter offered price',
        pricePositive: 'Price must be greater than 0',
        offerOnlyExhibited: 'Offers can only be made on exhibited artworks',
        cannotOfferOwnArtwork: 'You cannot make an offer on your own artwork',
        unreadCount: 'offers',
        viewOffers: 'View Offers',
        payment: 'Payment',
        paymentUnpaid: 'Unpaid',
        paymentPaid: 'Paid',
        paymentMissing: 'Payment not found',
        openDetail: 'Detail',
        payNow: 'Pay now',
      },
      artworkApprovals: {
        artworkApprovals: 'Artwork Approvals Overview',
        allArtworks: 'All',
        approvedArtworks: 'Approved',
        pendingArtworks: 'Not Approved',
        rejectedArtworks: 'Rejected',
        noArtworksWithEvents: 'No artwork with events',
        artwork: 'Artwork',
        author: 'Author',
        price: 'Price',
        status: 'Status',
        eventCount: 'Event Count',
        actions: 'Actions',
        hideEvents: 'Hide',
        showEvents: 'Show',
        events: 'Events',
        eventsFor: 'Events for',
        type: 'Type',
        createdAt: 'Created',
        approvedAt: 'Approved',
        notApproved: 'Not approved',
        approveEvent: 'Approve Event',
        rejectEvent: 'Reject Event',
        rejectReason: 'Reason for rejection:',
        rejectPlaceholder: 'Explain why you are rejecting this event...',
        confirmApproveEvent: 'Are you sure you want to approve this event?',
        confirmRejectEvent: 'Are you sure you want to reject this event?',
        approveButton: 'Approve',
        rejectButton: 'Reject',
        cancelButton: 'Cancel',
        loadingArtworks: 'Loading...',
        typeCreated: 'Created',
        typeUpdated: 'Updated',
        typePriceChange: 'Price change',
        typeStatusChange: 'Status change',
        typeDeleted: 'Deleted',
        typeOwnershipChange: 'Ownership change',
        eventStatusApproved: 'Approved',
        eventStatusPending: 'Pending',
        eventStatusRejected: 'Rejected',
        statusVystaveno: 'Exhibited',
        statusZrušeno: 'Cancelled',
        statusSkryto: 'Hidden',
      },
      admin: {
        users: 'Users',
        approvals: 'Approvals',
        events: 'Events',
        profileApprovals: 'Personal Data',
        managementUsers: 'User Management',
        settings: 'Settings',
        payments: 'Payments',
        newUser: 'New User',
        username: 'Username',
        email: 'Email',
        role: 'Role',
        created: 'Created',
        approve: 'Approve',
        reject: 'Reject',
        account: 'Account',
        userProfile: 'Profile',
        authorApprovals: 'Author Profile Approvals',
        noPendingApprovals: 'No pending author profile approvals',
        pendingApprovalsCount: 'Pending approvals',
        artworkTypes: 'artwork types',
        pendingBios: 'Pending Biographies',
        pendingArtworkTypes: 'Pending Artwork Types',
        bioDetail: 'Biography Detail',
        failedFetchPendingApprovals: 'Failed to fetch pending approvals',
        failedApproveBio: 'Failed to approve biography',
        failedRejectBio: 'Failed to reject biography',
        failedApproveType: 'Failed to approve artwork type',
        failedRejectType: 'Failed to reject artwork type',
      },
      settings: {
        title: 'Application Settings',
        createNew: 'Create Setting',
        noSettings: 'No settings',
        key: 'Key',
        value: 'Value',
        description: 'Description',
        updatedAt: 'Updated at',
        actions: 'Actions',
        editSetting: 'Edit Setting',
        createSetting: 'Create Setting',
        edit: 'Edit',
        delete: 'Delete',
        create: 'Create',
        saveSettings: 'Save Settings',
        loadError: 'Error loading settings',
        saveError: 'Error saving settings',
        saveSuccess: 'Settings saved successfully',
        createSuccess: 'Settings created successfully',
        deleteSuccess: 'Settings deleted successfully',
        galleryBankAccount: 'Gallery Bank Account Number',
        galleryCommissionPercent: 'Gallery Commission Percentage (%)',
        galleryName: 'Gallery Name',
        galleryEmail: 'Gallery Email',
        galleryPhone: 'Gallery Phone',
        vatRate: 'VAT Rate (%)',
        currency: 'Currency',
        minOrderAmount: 'Minimum Order Amount',
        shippingEnabled: 'Enable Shipping',
        paymentGatewayEnabled: 'Enable Payment Gateway',
        registrationEnabled: 'Enable Registration',
      },
      authorBio: {
        authorProfile: 'Author Profile',
        biography: 'Biography',
        biographyCzech: 'Biography (Czech)',
        biographyEnglish: 'Biography (English)',
        refresh: '🔄 Refresh',
        refreshTooltip: 'Reload profile (e.g. after admin approval)',
        refreshProfile: 'Refresh',
        pendingApproval: '⏳ Your profile is waiting for admin approval',
        approved: 'Approved',
        pending: 'Pending Approval',
        aboutYou: 'About You',
        describeYourself: 'Describe yourself and your work',
        describeYourselfEnglish: 'Describe yourself and your work in English',
        aboutYouPlaceholder: 'Write something about yourself, your work, inspiration...',
        aboutYouPlaceholderEnglish: 'Write something about yourself, your work, inspiration...',
        artworkTypes: 'Artwork Types',
        selectArtworkTypes: 'Select the types of artwork you create. Once approved by admin, you will be able to create artworks of these types.',
        saving: '⏳ Saving...',
        saveProfile: '💾 Save Profile',
        saveProfileButton: 'Save Profile',
        changesNeedApproval: 'Profile changes must be approved by admin',
        profileSubmitted: 'Profile submitted for admin approval',
      },
      profile: {
        myProfile: 'My Profile',
        basicInfo: 'Basic Information',
        username: 'Username',
        email: 'Email',
        role: 'Role',
        personalData: 'Personal Data',
        birthNumber: 'Birth Number',
        birthNumberFormat: 'Format: YYMMDD/XXXX',
        birthNumberPlaceholder: 'e.g. 123456/7890',
        permanentAddress: 'Permanent Address',
        correspondenceAddress: 'Correspondence Address',
        street: 'Street and Number',
        streetPlaceholder: 'e.g. New 123',
        city: 'City',
        cityPlaceholder: 'e.g. Prague',
        postalCode: 'Postal Code',
        postalCodePlaceholder: 'e.g. 110 00',
        country: 'Country',
        countryPlaceholder: 'e.g. Czech Republic',
        bankingDetails: 'Banking Details',
        accountNumber: 'Account Number',
        accountNumberPlaceholder: 'e.g. 123-456789012/0100',
        bankCode: 'Bank Code',
        bankCodePlaceholder: 'e.g. 0100',
        bankName: 'Bank Name',
        bankNamePlaceholder: 'e.g. Česká spořitelna',
        notFilled: 'Not filled',
        approved: '✅ Approved',
        pending: '⚠️ Not Approved',
        approvalPending: '⚠️ Profile Awaiting Administrator Approval',
        approvalPendingMessage: 'Your personal data has been saved but has not yet been approved. Please wait for administrator review.',
        approvalStatus: 'Approval Status',
        approvedDate: 'Approved',
        editProfile: 'Edit Profile',
        saving: 'Saving...',
        failedLoadProfile: 'Failed to load profile',
        failedUpdateProfile: 'Failed to update profile',
        profileNotFound: 'Profile not found',
        approvals: 'Profile Approvals',
        pendingApprovals: 'Pending Approval',
        approvedProfiles: 'Approved',
        rejectedProfiles: 'Rejected',
        allUsers: 'All Users',
        registered: 'Registered',
        profileDetails: 'Profile Details',
        approveProfileButton: 'Approve Profile',
        rejectProfileButton: 'Reject Profile',
        detail: 'Detail',
        failedFetchUsers: 'Failed to fetch users',
        failedApproveProfile: 'Failed to approve profile',
        failedRejectProfile: 'Failed to reject profile',
      },
      buttons: {
        save: 'Save Changes',
        create: 'Create',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        search: 'Search',
        clear: 'Clear',
        new: 'New',
        refresh: 'Refresh',
        approve: 'Approve',
        reject: 'Reject',
        buy: 'Buy',
        confirmPayment: 'Confirm Payment',
        sendInvoice: 'Send Invoice',
        backToGallery: 'Back to Gallery',
      },
      artworkDetail: {
        notFound: 'Artwork not found',
        loadError: 'Error loading artwork details',
        noImage: 'No image',
        description: 'Description',
        author: 'Author',
        price: 'Price',
        notForSale: 'This artwork is not for sale',
        notAvailable: 'This artwork is currently not available for purchase',
        payWithQr: 'Please complete payment for the artwork via QR code',
        alreadyExhibited: 'This artwork has been exhibited',
        loginRequired: 'You must be logged in to purchase',
        noPriceSet: 'Price not set',
        confirmPurchase: 'Do you really want to buy "{{title}}" for {{price}}?',
        purchaseSuccess: 'Purchase successful! Payment is awaiting admin confirmation.',
        purchaseError: 'Failed to complete purchase',
        processing: 'Processing...',
        history: 'Artwork History',
        noHistory: 'No approved history',
        date: 'Date',
        eventType: 'Event Type',
        status: 'Status',
        details: 'Details',
      },
      payments: {
        title: 'Payment Management',
        myPayments: 'My Payments',
        adminOnly: 'Admin access only',
        loadError: 'Error loading payments',
        noPayments: 'No payments yet',
        id: 'ID',
        varSymbol: 'Var. Symbol',
        artwork: 'Artwork',
        buyer: 'Buyer',
        seller: 'Seller',
        role: 'Role',
        price: 'Price',
        commission: 'Commission',
        sellerAmount: 'To Seller',
        status: 'Status',
        created: 'Created',
        actions: 'Actions',
        paidAt: 'Paid',
        statusUnpaid: 'Unpaid',
        statusPaid: 'Paid',
        statusCancelled: 'Cancelled',
        confirmPaymentTitle: 'Confirm Payment',
        confirmSuccess: 'Payment confirmed',
        confirmError: 'Error confirming payment',
        paymentMethod: 'Payment Method',
        paymentMethodPlaceholder: 'e.g. Bank Transfer, Cash',
        transactionId: 'Transaction ID',
        transactionIdPlaceholder: 'Optional',
        notes: 'Notes',
        notesPlaceholder: 'Optional notes',
        sendInvoiceTitle: 'Send Invoice',
        invoiceNumber: 'Invoice Number',
        invoiceNumberRequired: 'Invoice number is required',
        invoiceNumberPlaceholder: 'e.g. 2025001',
        invoiceSent: 'Invoice sent',
        invoiceError: 'Error sending invoice',
        cannotBuyOwnArtwork: 'You cannot buy your own artwork',
        scanQRCode: 'Scan QR code to pay',
        amount: 'Amount',
        variableSymbol: 'Variable Symbol',
        description: 'Description',
        bankAccount: 'Bank Account',
        paymentPending: 'Waiting for payment',
        paymentConfirmed: 'Payment confirmed',
        roleBuyer: 'Buyer',
        roleSeller: 'Seller',
        asBuyer: 'As Buyer',
        asSeller: 'As Seller',
        allPayments: 'All Payments',
        confirmed: 'Confirmed',
        invoice: 'Invoice',
        view: 'View',
        viewAll: 'All Payments',
        viewByUser: 'By User',
        filterAll: 'All',
        sellersTotal: 'Total to Sellers',
      },
      messages: {
        loadingUsers: 'Loading users...',
        noUsers: 'No users to display',
        userCreated: 'User was created',
        userUpdated: 'User was updated',
        userDeleted: 'User was deleted',
        artworkCreated: 'Artwork was created',
        artworkUpdated: 'Artwork was updated',
        artworkDeleted: 'Artwork was deleted',
        profileUpdated: 'Profile was updated',
        confirmDelete: 'Are you sure you want to delete?',
        error: 'An error occurred',
      },
    },
  },
};

const savedLanguage = localStorage.getItem('language') || 'cs';

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
